<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Tiny Dancer</h1>
</div>
</div>
<h3 style="text-align: center;">
	The Incredible True Story of a Young Burn Victim’s Journey from Afghanistan</h3>
<h4 style="text-align: center;">
</h4>
<h4 style="text-align: center;">
	Anthony Flacco</h4>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap113193.vue?1d30454c